export const menuRoles = {
    itemMenu: {
        fornecedor: {
            roles: ['PORTAL_FORNECEDOR_EXTERNO']
        }
    }
};
